<script setup lang="ts">
import { AfSkeleton } from '@af-lib/ui-lib';
</script>

<template>
  <div class="d-flex flex-column gap-16">
    <AfSkeleton v-for="i in 3" :key="i" type="block-m" style="height: auto" class="skeleton-container pa-4">
      <div class="mb-5">
        <v-row noGutters class="justify-space-between">
          <v-col cols="6">
            <AfSkeleton type="line-s" dark />
          </v-col>
          <v-col cols="4">
            <AfSkeleton type="line-s" dark />
          </v-col>
        </v-row>
        <v-row noGutters class="mt-1 justify-space-between">
          <v-col cols="2">
            <AfSkeleton type="line-xs" dark />
          </v-col>
          <v-col cols="2">
            <AfSkeleton type="line-xs" dark />
          </v-col>
        </v-row>
      </div>
      <v-row noGutters class="justify-space-between align-center">
        <v-col cols="6">
          <AfSkeleton type="line-s" dark />
        </v-col>
        <v-col cols="1">
          <AfSkeleton type="circle-s" dark />
        </v-col>
      </v-row>
    </AfSkeleton>
  </div>
</template>
